import Vue from 'vue'
import delayHydration from './hydration/hydrationRace.js'

import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_d85e2884 from 'nuxt_plugin_plugin_d85e2884' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_db7a20d0 from 'nuxt_plugin_sentryserver_db7a20d0' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_2c897e10 from 'nuxt_plugin_sentryclient_2c897e10' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_libcomponent4fa203f2_70676a78 from 'nuxt_plugin_libcomponent4fa203f2_70676a78' // Source: ./lib.component.4fa203f2.js (mode: 'all')
import nuxt_plugin_libplugin37c49a52_e4b73d44 from 'nuxt_plugin_libplugin37c49a52_e4b73d44' // Source: ./lib.plugin.37c49a52.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_0cd7bb7c from 'nuxt_plugin_cookieuniversalnuxt_0cd7bb7c' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_gtm_753fefaa from 'nuxt_plugin_gtm_753fefaa' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_interpolation_a3a6c634 from 'nuxt_plugin_interpolation_a3a6c634' // Source: ./interpolation.js (mode: 'client')
import nuxt_plugin_pluginutils_d0a86632 from 'nuxt_plugin_pluginutils_d0a86632' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_11ecbc72 from 'nuxt_plugin_pluginrouting_11ecbc72' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_6690d43d from 'nuxt_plugin_pluginmain_6690d43d' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_httpserver_9b6f6c7e from 'nuxt_plugin_httpserver_9b6f6c7e' // Source: ./http.server.js (mode: 'server')
import nuxt_plugin_http_682403fc from 'nuxt_plugin_http_682403fc' // Source: ./http.js (mode: 'all')
import nuxt_plugin_axios_f3cf7858 from 'nuxt_plugin_axios_f3cf7858' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_image_711f40cf from 'nuxt_plugin_image_711f40cf' // Source: ./image.js (mode: 'all')
import nuxt_plugin_deviceplugin_972e7142 from 'nuxt_plugin_deviceplugin_972e7142' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_capacitor_7f9b636b from 'nuxt_plugin_capacitor_7f9b636b' // Source: ../plugins/capacitor.js (mode: 'client')
import nuxt_plugin_ssr_3a86d4ca from 'nuxt_plugin_ssr_3a86d4ca' // Source: ../plugins/ssr.js (mode: 'all')
import nuxt_plugin_globalserver_3d1005a0 from 'nuxt_plugin_globalserver_3d1005a0' // Source: ../plugins/global-server.js (mode: 'all')
import nuxt_plugin_global_f21f4e84 from 'nuxt_plugin_global_f21f4e84' // Source: ../plugins/global.js (mode: 'client')
import nuxt_plugin_combinedinject_46de0ff4 from 'nuxt_plugin_combinedinject_46de0ff4' // Source: ../plugins/combined-inject.js (mode: 'all')
import nuxt_plugin_combinedinjectclient_b94717bc from 'nuxt_plugin_combinedinjectclient_b94717bc' // Source: ../plugins/combined-inject-client.js (mode: 'client')
import nuxt_plugin_client_035ad0d4 from 'nuxt_plugin_client_035ad0d4' // Source: ../plugins/client.js (mode: 'client')
import nuxt_plugin_lodash_5d4c7b8c from 'nuxt_plugin_lodash_5d4c7b8c' // Source: ../plugins/lodash.js (mode: 'all')
import nuxt_plugin_vuemobiledetection_366329a0 from 'nuxt_plugin_vuemobiledetection_366329a0' // Source: ../plugins/vue-mobile-detection.js (mode: 'all')
import nuxt_plugin_vmoneyspinner_09bdba50 from 'nuxt_plugin_vmoneyspinner_09bdba50' // Source: ../plugins/v-money-spinner.js (mode: 'client')
import nuxt_plugin_vuevideojs7_72d1d932 from 'nuxt_plugin_vuevideojs7_72d1d932' // Source: ../plugins/vue-videojs7.js (mode: 'client')
import nuxt_plugin_loaddidomi_227e61da from 'nuxt_plugin_loaddidomi_227e61da' // Source: ../plugins/load-didomi.js (mode: 'client')
import nuxt_plugin_gtm_63638066 from 'nuxt_plugin_gtm_63638066' // Source: ../plugins/gtm.js (mode: 'client')
import nuxt_plugin_zendesk_73eb44b1 from 'nuxt_plugin_zendesk_73eb44b1' // Source: ../plugins/zendesk.js (mode: 'client')
import nuxt_plugin_braze_1b867e1e from 'nuxt_plugin_braze_1b867e1e' // Source: ../plugins/braze.js (mode: 'client')
import nuxt_plugin_inactivitytracker_49fa4b7c from 'nuxt_plugin_inactivitytracker_49fa4b7c' // Source: ../plugins/inactivity-tracker.js (mode: 'client')
import nuxt_plugin_initauthclient_62ebc8ad from 'nuxt_plugin_initauthclient_62ebc8ad' // Source: ../plugins/init-auth.client.js (mode: 'client')
import nuxt_plugin_getdebugcookies_60280262 from 'nuxt_plugin_getdebugcookies_60280262' // Source: ../plugins/get-debug-cookies.js (mode: 'client')
import nuxt_plugin_socketclient_03aac5f2 from 'nuxt_plugin_socketclient_03aac5f2' // Source: ../plugins/socket.client.js (mode: 'client')
import nuxt_plugin_libnuxtclientinitpluginclient7f81a51f_95809f98 from 'nuxt_plugin_libnuxtclientinitpluginclient7f81a51f_95809f98' // Source: ./lib.nuxt-client-init.plugin.client.7f81a51f.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    await delayHydration()
}

  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Bet777 ES","htmlAttrs":{"lang":"es","class":"dark"},"meta":[{"charset":"utf-8"},{"hid":"description","name":"description","content":""}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-W8TSSC&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_d85e2884 === 'function') {
    await nuxt_plugin_plugin_d85e2884(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_db7a20d0 === 'function') {
    await nuxt_plugin_sentryserver_db7a20d0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_2c897e10 === 'function') {
    await nuxt_plugin_sentryclient_2c897e10(app.context, inject)
  }

  if (typeof nuxt_plugin_libcomponent4fa203f2_70676a78 === 'function') {
    await nuxt_plugin_libcomponent4fa203f2_70676a78(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin37c49a52_e4b73d44 === 'function') {
    await nuxt_plugin_libplugin37c49a52_e4b73d44(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_0cd7bb7c === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_0cd7bb7c(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_753fefaa === 'function') {
    await nuxt_plugin_gtm_753fefaa(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_interpolation_a3a6c634 === 'function') {
    await nuxt_plugin_interpolation_a3a6c634(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_d0a86632 === 'function') {
    await nuxt_plugin_pluginutils_d0a86632(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_11ecbc72 === 'function') {
    await nuxt_plugin_pluginrouting_11ecbc72(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_6690d43d === 'function') {
    await nuxt_plugin_pluginmain_6690d43d(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_httpserver_9b6f6c7e === 'function') {
    await nuxt_plugin_httpserver_9b6f6c7e(app.context, inject)
  }

  if (typeof nuxt_plugin_http_682403fc === 'function') {
    await nuxt_plugin_http_682403fc(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_f3cf7858 === 'function') {
    await nuxt_plugin_axios_f3cf7858(app.context, inject)
  }

  if (typeof nuxt_plugin_image_711f40cf === 'function') {
    await nuxt_plugin_image_711f40cf(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_972e7142 === 'function') {
    await nuxt_plugin_deviceplugin_972e7142(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_capacitor_7f9b636b === 'function') {
    await nuxt_plugin_capacitor_7f9b636b(app.context, inject)
  }

  if (typeof nuxt_plugin_ssr_3a86d4ca === 'function') {
    await nuxt_plugin_ssr_3a86d4ca(app.context, inject)
  }

  if (typeof nuxt_plugin_globalserver_3d1005a0 === 'function') {
    await nuxt_plugin_globalserver_3d1005a0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_global_f21f4e84 === 'function') {
    await nuxt_plugin_global_f21f4e84(app.context, inject)
  }

  if (typeof nuxt_plugin_combinedinject_46de0ff4 === 'function') {
    await nuxt_plugin_combinedinject_46de0ff4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_combinedinjectclient_b94717bc === 'function') {
    await nuxt_plugin_combinedinjectclient_b94717bc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_client_035ad0d4 === 'function') {
    await nuxt_plugin_client_035ad0d4(app.context, inject)
  }

  if (typeof nuxt_plugin_lodash_5d4c7b8c === 'function') {
    await nuxt_plugin_lodash_5d4c7b8c(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemobiledetection_366329a0 === 'function') {
    await nuxt_plugin_vuemobiledetection_366329a0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vmoneyspinner_09bdba50 === 'function') {
    await nuxt_plugin_vmoneyspinner_09bdba50(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuevideojs7_72d1d932 === 'function') {
    await nuxt_plugin_vuevideojs7_72d1d932(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_loaddidomi_227e61da === 'function') {
    await nuxt_plugin_loaddidomi_227e61da(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtm_63638066 === 'function') {
    await nuxt_plugin_gtm_63638066(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_zendesk_73eb44b1 === 'function') {
    await nuxt_plugin_zendesk_73eb44b1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_braze_1b867e1e === 'function') {
    await nuxt_plugin_braze_1b867e1e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_inactivitytracker_49fa4b7c === 'function') {
    await nuxt_plugin_inactivitytracker_49fa4b7c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_initauthclient_62ebc8ad === 'function') {
    await nuxt_plugin_initauthclient_62ebc8ad(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_getdebugcookies_60280262 === 'function') {
    await nuxt_plugin_getdebugcookies_60280262(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_socketclient_03aac5f2 === 'function') {
    await nuxt_plugin_socketclient_03aac5f2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_libnuxtclientinitpluginclient7f81a51f_95809f98 === 'function') {
    await nuxt_plugin_libnuxtclientinitpluginclient7f81a51f_95809f98(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
